import { memo, useState } from 'react';
import classnames from 'classnames';

import { Menu } from 'antd';

import { ReactComponent as ChevronUpIcon } from '@Icons/additional/chevron-up-double.svg';
import useMenuItemNavigator from '../../hook/useMenuItemNavigator';
import useUpdateItems from '../../hook/useUpdateItems';
import { getSelectedMenuItem } from '../../utils/getSelectedMenuItem';

import styles from './accordion-side-menu.module.css';

interface SideMenuProps {
  isMobile?: boolean;
  pageType?: string;
}

const SideMenu: React.FC<SideMenuProps> = ({ isMobile, pageType }) => {
  const { menuItemNavigate } = useMenuItemNavigator();
  const selectedMenuItem = getSelectedMenuItem(pageType);
  const [selectedItem, setSelectedItem] = useState(selectedMenuItem);

  const updatedItems = useUpdateItems(selectedItem);

  return (
    <Menu
      mode={isMobile ? 'horizontal' : 'inline'}
      selectedKeys={selectedMenuItem}
      defaultOpenKeys={['menuItem1']}
      items={updatedItems}
      overflowedIndicator={
        <div className={styles.moreButton}>
          <ChevronUpIcon />
          <span>More</span>
        </div>
      }
      className={classnames(
        styles.accordionSideMenu,
        isMobile ? 'mobile-view' : null,
        isMobile
          ? 'trojan-glassphormism-box trojan-glassphormism-box-shadow'
          : null
      )}
      onClick={(event) => menuItemNavigate(event.key)}
      onSelect={({ selectedKeys }) => setSelectedItem(selectedKeys)}
    />
  );
};

export default memo(SideMenu);
